var map = {
	"./Features-Block-Saved-DA-DK-D.avif": 1823,
	"./Features-Block-Saved-DE-DE-D.avif": 70573,
	"./Features-Block-Saved-EN-GB-D.avif": 50615,
	"./Features-Block-Saved-EN-US-D.avif": 27182,
	"./Features-Block-Saved-ES-ES-D.avif": 30311,
	"./Features-Block-Saved-ES-MX-D.avif": 39478,
	"./Features-Block-Saved-FR-FR-D.avif": 22247,
	"./Features-Block-Saved-IT-IT-D.avif": 27333,
	"./Features-Block-Saved-NB-NO-D.avif": 81756,
	"./Features-Block-Saved-NL-NL-D.avif": 15083,
	"./Features-Block-Saved-PL-PL-D.avif": 45011,
	"./Features-Block-Saved-PT-BR-D.avif": 98919,
	"./Features-Block-Saved-PT-PT-D.avif": 66131,
	"./Features-Block-Saved-SV-SE-D.avif": 81424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4312;